import { useNotificationError } from "@/context/error-provider";
import { ErrorNotificationType } from "@/pages/components/error-notification";
import httpClient from "@/services";
import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

export type ILocate = {
  mbrFirstName: string;
  mbrLastName: string;
  mbrZip: string;
  mbrDob: string;
  mbrInputEmail: string;
};

export type ILocateResponse = {
  message: string;
  success: boolean;
  status: string;
};

export const locateUser = (userInfo: ILocate) => {
  const url = "/login/findUserOrMember";
  const config = {
    headers: {
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
    },
  };
  const data = {
    mbrFirstName: userInfo.mbrFirstName,
    mbrLastName: userInfo.mbrLastName,
    mbrZip: userInfo.mbrZip,
    mbrDob: userInfo.mbrDob,
    mbrInputEmail: userInfo.mbrInputEmail ?? "",
  };

  return httpClient.post(url, data, config).then((res) => res.data);
};

const useLocate = () => {
  const { addError } = useNotificationError();

  return useMutation({
    mutationKey: ["forgotUsername"],
    mutationFn: (userInfo: ILocate) => locateUser(userInfo),
    onSuccess: (data: ILocateResponse) => {
      if (!data.success) {
        addError({
          message: data.message,
          type: ErrorNotificationType.ERROR,
        });
      } else {
        addError({
          message: data.message,
          type: ErrorNotificationType.INFO,
        });
      }
    },
    onError: (error: AxiosError) => {
      addError({
        message: error.message,
        type: ErrorNotificationType.ERROR,
      });
    },
  });
};

export default useLocate;
